<template>
  <div
    class="footer-wrapper d-flex flex-column justify-content-center align-items-center"
  >
    <div
      class="footer-content py-5 w-100 d-flex flex-column justify-content-center align-items-center"
    >
      <div class="tournament-logo">
        <h1
          class="text-center tournament-title font-weight-bold m-0 text-uppercase"
        >
          Wigame Origins<br />by MSE
        </h1>
      </div>
    </div>
    <div
      class="container d-flex justify-content-between align-items-center my-5 py-3"
    >
      <div>
        <img :src="require('@/assets/logos/wigame-logo.svg')" class="w-75" />
      </div>
      <div class="">
        <RSLinks />
      </div>
    </div>
    <div class="powered-by-lgame w-100">
      <PoweredByLgame />
    </div>
  </div>
</template>
<script>
import PoweredByLgame from "./PoweredByLgame.vue";
import RSLinks from "./RSLinks.vue";
export default {
  name: "LPFooter",
  components: {
    PoweredByLgame,
    RSLinks,
  },
};
</script>
<style lang="css" scoped>
.tournament-title {
  font-family: "race_sportregular";
}
.footer-wrapper {
  position: relative;
}
.footer-content {
  background-image: url("@/assets/footer-bg.png");
  background-size: 100% 100%;
  object-fit: cover;
  height: 500px;
}
.powered-by-lgame {
}
.footer-note {
  color: white;
  font-family: "Roboto mono";
}
.legal a {
  font-family: "urbanist", sans-serif;
  font-weight: 500;
  text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 768px) {
  .footer-wrapper {
    background-size: auto 100%;
    background-position: 70%;
    height: 480px;
  }
  .partners-logos img {
    height: 42px;
  }
  .footer-note {
    font-size: 0.8rem;
  }
}
</style>
